import { render, staticRenderFns } from "./ConnectedHubs.vue?vue&type=template&id=652a8d84"
import script from "./ConnectedHubs.vue?vue&type=script&lang=js"
export * from "./ConnectedHubs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports